export default function (cb) {
  if ('loading' !== document.readyState) {
    cb();
  }

  document.addEventListener('DOMContentLoaded', cb);
}
